import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  sit: 'No tenés tiempo de grabar',
  sin: 'Publicás cuando podés',
  con: 'Todo el mes grabado en 4 horas'
}, {
  sit: 'DMs sin respuesta',
  sin: 'Perdés ventas mientras dormís',
  con: 'ManyChat responde las 24hs'
}, {
  sit: 'Edición que te consume horas',
  sin: 'Lo hacés todo vos',
  con: 'Brief listo para delegar desde $2 USD'
}, {
  sit: 'No sabés si crecés',
  sin: 'Trabajás sin datos',
  con: 'Planilla de control con 5 métricas'
}, {
  sit: 'Cierres que no cierran',
  sin: 'Improvisás cada conversación',
  con: 'Script de 3 mensajes que no falla'
}, {
  sit: 'Negocio que depende de vos',
  sin: 'Si parás, para el negocio',
  con: 'Plan de Retiro Operativo en 90 días'
}];
export function ComparisonTable() {
  return <section className="w-full py-12 px-4 bg-base" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold text-text-main" data-id="element-49">
            ¿Qué suma NEGOCIO EN AUTOMÁTICO?
          </h2>
        </div>

        <div className="bg-alt rounded-2xl border border-primary/20 overflow-hidden" data-id="element-50">
          {/* Header */}
          <div className="grid grid-cols-3 p-4 md:p-6 border-b border-primary/20 bg-base/50 text-sm md:text-base font-bold" data-id="element-51">
            <div className="text-text-muted" data-id="element-52">Situación</div>
            <div className="text-red-400 flex items-center gap-2 justify-center md:justify-start" data-id="element-53">
              <X size={18} data-id="element-54" /> <span className="hidden md:inline" data-id="element-55">Sin él</span>
            </div>
            <div className="text-cta flex items-center gap-2 justify-center md:justify-start" data-id="element-56">
              <Check size={18} data-id="element-57" />{' '}
              <span className="hidden md:inline" data-id="element-58">Con él</span>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-primary/10" data-id="element-59">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`grid grid-cols-3 p-4 md:p-6 text-sm md:text-base items-center ${i % 2 === 0 ? 'bg-alt' : 'bg-base'}`} data-id="element-60">
                <div className="text-text-main font-medium pr-2" data-id="element-61">{row.sit}</div>
                <div className="text-text-muted pr-2 text-center md:text-left" data-id="element-62">
                  {row.sin}
                </div>
                <div className="text-text-main font-bold text-center md:text-left" data-id="element-63">
                  {row.con}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}